const selectorsListStyles = theme => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  height: '100%',
  overflowY: 'scroll',
  padding: theme.spacing(0, 0, 4.5),
  scrollbarWidth: 'none',
});

export default selectorsListStyles;
